import { Route, Routes } from "react-router-dom";
import AskPage from "./AskPage";
import ConversationPage from "./ConversationPage";
import HistoryPage from "./HistoryPage";

const AIPages = () => {
  return (
    <Routes>
      <Route path="ask" element={<AskPage />} />
      <Route path="ask/history" element={<HistoryPage />} />
      <Route path="ask/:id" element={<ConversationPage />} />
    </Routes>
  );
};

export default AIPages;
